import { render, staticRenderFns } from "./BimfaceAnnotation.vue?vue&type=template&id=966d1ce2&scoped=true"
import script from "./BimfaceAnnotation.vue?vue&type=script&lang=js"
export * from "./BimfaceAnnotation.vue?vue&type=script&lang=js"
import style0 from "./BimfaceAnnotation.vue?vue&type=style&index=0&id=966d1ce2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966d1ce2",
  null
  
)

export default component.exports